<template>
    <div>
        <o-field label="Job # *" :type="fieldType('dob_job_number')" :message="getError('dob_job_number')">
            <o-input placeholder="Job #" v-model="form.dob_job_number"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a Status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in permitStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        data () {
            return {
                form: {
                    dob_job_number: null,
                    job_number: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters({
                permitStatuses: 'permitStatuses'
            })
        }
    }
</script>
